import React, { useContext } from "react";

import { ThemeContext } from "../../contexts/ThemeContext";

import "./Internships.css";

import { internshipData } from "../../data/internshipData";
import InternshipsCard from "./InternshipsCard";

function Internship() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="experience"
      id="experience"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="experience-body">
        <div className="experience-description">
          <h1 style={{ color: theme.primary }}>Internships</h1>
          {internshipData.map((exp) => (
            <InternshipsCard
              key={exp.id}
              id={exp.id}
              jobtitle={exp.jobtitle}
              company={exp.company}
              skills={exp.skills}
              startYear={exp.startYear}
              endYear={exp.endYear}
            />
          ))}
        </div>
        <div className="experience-image">
          <img src={theme.internimg} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Internship;
